import {
  createBrowserRouter,
  Navigate,
  RouterProvider
} from "react-router-dom";

import { LoginLayout } from "../pages/Layout";
import {
  Error,
  Login,
} from "../pages";

const router = createBrowserRouter([
  {
    path: "",
  //   element: <Root/>,
    errorElement: <Error />,
    children: [
      {
        path: "",
        element: <LoginLayout />,
        children: [
          {
            path: "",
            element: <Login />,
          }
        ]
      },
      {
        path: "/*",
        element: <Navigate to="" />,
      }
    ],
  },
]);

export const PublicRouter = () => {
  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}
